import React, { useState } from "react";

/**
 * Accordion component: Hiển thị danh sách câu hỏi/câu trả lời dạng collapse.
 * Props:
 * - items: Array<{ question: string, answer: string }>
 * - className: optional, custom style
 */
export interface AccordionItem {
  question: string;
  answer: string;
}

interface AccordionProps {
  items: AccordionItem[];
  className?: string;
}

const Accordion: React.FC<AccordionProps> = ({ items, className = "" }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div className={`w-full rounded-lg border border-gray-200 dark:border-gray-700 divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800 ${className}`}>
      {items.map((item, idx) => (
        <div key={idx}>
          <button
            className="w-full flex justify-between items-center px-6 py-4 text-left focus:outline-none hover:bg-gray-50 dark:hover:bg-gray-700 transition"
            onClick={() => handleToggle(idx)}
            aria-expanded={openIndex === idx}
            aria-controls={`faq-panel-${idx}`}
          >
            <span className="font-medium text-gray-900 dark:text-white">{item.question}</span>
            <svg
              className={`w-5 h-5 ml-2 transform transition-transform ${openIndex === idx ? "rotate-180" : ""}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <div
            id={`faq-panel-${idx}`}
            className={`px-6 pb-4 text-gray-700 dark:text-gray-300 text-sm transition-all duration-300 ${openIndex === idx ? "block" : "hidden"}`}
          >
            {item.answer}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;
